<!--
 * @Description: 供应商来料
 * @Author: wangwangwang
 * @Date: 2020-09-21 14:09:06
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-12-29 15:03:54
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main style="display: flex">
        <div>
          <div class="header_right" @click="showCardNav = !showCardNav">
            <div class="title">搜索</div>
            <div>
              <transition name="from"></transition>
              <span v-show="!showCardNav">
                <i style="margin-right: 5px" class="el-icon-arrow-down"></i>
              </span>
              <transition name="to"></transition>
              <span v-show="showCardNav">
                <i style="margin-right: 5px" class="el-icon-arrow-up"></i>
              </span>
            </div>
          </div>
          <div v-show="showCardNav" class="hr"></div>
          <el-collapse-transition>
            <div v-show="showCardNav">
              <div class="search">
                <span style="display: inline-block;margin-bottom: 10px;">
                  <span style="margin-right: 12px">特材原料名称</span>
                  <el-input v-model="tableParam.productName" style="width: 200px" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
                </span>
                <!-- <span style="margin-left: 24px">
                  <span style="margin-right: 12px">原料型号</span>
                  <el-input v-model="tableParam.productType" style="width: 200px" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
                </span> -->
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">状态</span>
                  <el-select v-model="tableParam.dataStatus" placeholder="请选择" style="width: 120px">
                    <el-option label="全部" :value="null"></el-option>
                    <el-option label="待处理" :value="0"></el-option>
                    <el-option label="已入库" :value="1"></el-option>
                    <el-option label="已退料" :value="2"></el-option>
                    <el-option label="已提交检验" :value="3"></el-option>
                  </el-select>
                </span>
                <el-button icon="el-icon-search" size="medium" class="bottom_all" @click="(tableParam.page = 1), gettableData()">查 询</el-button>
                <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
              </div>
            </div>
          </el-collapse-transition>
          <div class="hr"></div>
          <div class="card">
            <div class="card_nav">
              <div>
                <el-button v-if="ButtonList.findIndex(res=>(res.buttonValue=='TIANJIA'))!==-1" size="small" class="bottom_all" style="margin-left: 0" @click="addFromDate('添加')">
                  <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                  添加
                </el-button>
              </div>
              <div>
                <el-dropdown :hide-on-click="false" trigger="click" style="margin: 0 20px">
                  <el-link :underline="false">
                    <span class="el-icon--left">
                      <i class="iconfont iconicon_button_filtrate"></i>
                    </span>
                    筛选
                  </el-link>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="(item, index) in table" :key="index">
                      <el-checkbox v-model="item.status">{{
                        item.label
                        }}</el-checkbox>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
            <div v-loading="tableLoading" class="card_info" :style="style">
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="tableData" tooltip-effect="dark">
                <template v-for="(item, index2) in table">
                  <el-table-column v-if="item.status" :key="index2" :label="item.label" align="left" :min-width="item.width" :fixed="item.label =='操作'?'right':false">
                    <template slot-scope="scope">
                      <div v-if="item.label == '操作'">
                        <el-button v-if="scope.row.dataStatus == 0&&ButtonList.findIndex(res=>(res.buttonValue=='XIUGAI'))!==-1" class="bottom_one" size="mini" @click="getCantractSup(scope.row.contractId,scope.row.companyId,scope.row.rawId), productListFun(scope.row.companyId),updateFromDate(scope.row, '修改' )">
                          修改
                        </el-button>
                        <el-button v-if="scope.row.dataStatus==0&&ButtonList.findIndex(res=>(res.buttonValue=='JIANYAN'))!==-1" class="bottom_one" size="mini" @click="open('addDialog2',scope.row)">
                          原物料检验
                        </el-button>
                        <el-button v-if="(scope.row.dataStatus!=2 && scope.row.dataStatus != 1)&&ButtonList.findIndex(res=>(res.buttonValue=='RUKU'))!==-1" class="bottom_one" size="mini" @click="open('addDialog1',scope.row)">
                          入库
                        </el-button>
                      </div>
                      <div v-else-if="item.label == '状态'">
                        <span v-if="scope.row.dataStatus == 3" style="color: #969799">已提交检验</span>
                        <span v-else-if="scope.row.dataStatus == 0" style="color: #969799">待处理</span>
                        <span v-else-if="scope.row.dataStatus == 1" style="color: #00a754">已入库</span>
                        <span v-else style="color: red">已退料</span>
                      </div>
                      <span v-else>{{ scope.row[item.prop] }}</span>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </div>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize" :page-sizes="[10, 20, 30, 40,50,100,200,500,1000]" layout="prev,pager,sizes,next,jumper" :total="total" @size-change="sizeChange" @current-change="gettableData()"></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div>
    </el-container>
    <!-- 添加 -->
    <el-dialog v-dialogDrag :visible.sync="addDialog" width="480px" :close-on-click-modal="false" :before-close="resetFromDate">
      <span slot="title" class="dialog-title">{{ addDialogTitle }}</span>
      <div class="dialoginfo">
        <el-form ref="reffromDate" :rules="rules" :inline="true" :model="fromDate" label-width="110px">
          <el-form-item prop="companyId">
            <span slot="label" style="color: #ff0000">所属单位</span>
            <el-select ref="company" v-model="fromDate.companyId" placeholder="请选择" @change="$nextTick(()=>{fromDate.company = $refs.company.selectedLabel}),productListFun(fromDate.companyId)">
              <el-option v-for="(item,index) in companyList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="productId">
            <span slot="label" style="color: #ff0000">特材原料</span>
            <el-select  v-model="fromDate.productId" placeholder="请选择" filterable >
              <el-option v-for="(item, index) in productList" :key="index" :label="item.rawtName" :value="item.id" @click.native="getCantractSup('',fromDate.companyId,item.rawId,item)"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="contractId">
            <span slot="label">供应商合同</span>
            <el-select ref="contractId" v-model="fromDate.contractId" placeholder="请选择" filterable >
              <el-option v-for="(item, index) in contractList" :key="index" :label="item.name" :value="item.id" @click.native="selectContract(item)"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item >
            <span slot="label">原料供应商</span>
            <el-select ref="supplier" v-model="fromDate.supplier" disabled placeholder="请选择" filterable @change="$nextTick(()=>{fromDate.supplier = $refs.supplier.selectedLabel})">
              <el-option v-for="(item, index) in stationLost" :key="index" :label="item.supplier+'-'+item.supplierType" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="cooperativeUnitId">
            <span slot="label">协作单位</span>
            <el-select ref="cooperativeUnitId" v-model="fromDate.cooperativeUnitId" placeholder="请选择" filterable @change="$nextTick(()=>{fromDate.cooperativeUnit = $refs.cooperativeUnitId.selectedLabel})">
              <el-option v-for="(item, index) in cooperationsList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="remark">
            <span slot="label">备注</span>
            <el-input v-model="fromDate.remark" placeholder="请填写备注" class="textarea" type="textarea" resize="none" rows="5"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetFromDate">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="pagessubmitFromDate()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 入库 -->
    <el-dialog v-dialogDrag :visible.sync="addDialog1" width="480px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">入库</span>
      <div>
        <div style="margin-bottom:5px;display:flex;font-weight: 600;">
          <div style="flex:1;">特材原料：{{lowData.specialMaterialsMannage.rawtName || ''}}</div>
          <div style="flex:1;">原料罐：{{lowData.specialMaterialsMannage.tank || ''}}</div>
        </div>
        <div style="margin-top:20px;margin-bottom:5px;display:flex;font-weight: 600;">
          <div style="flex:1;display:flex;">入库量:<el-input v-model="lowData.specialMaterialsMannage.stock" type="Number" placeholder="请输入" style="width:200px;margin-left:10px">
                <template slot="append">吨</template>
          </el-input></div>
        </div>
        <div style="margin-top:20px;margin-bottom:5px;display:flex;font-weight: 600;">
          <div style="flex:1;display:flex;">过磅时间:
            <el-date-picker
                v-model="lowData.inventoryTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width:200px;margin-left:10px"
                placeholder="选择过磅时间">
            </el-date-picker>
          </div>
        </div>
        <!-- <div style="padding-bottom:15px">
          <el-button size="mini" class="bottom_all" style="margin-left: 0" :disabled="tankList.length==0" @click="additem()">
            <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
            添加
          </el-button>
        </div> -->
        <!-- <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="lowData.tanks" tooltip-effect="dark" :row-class-name="className">
          <el-table-column label="原料罐" align="center">
            <template slot-scope="scope">
              <el-select v-model="scope.row.id" placeholder="请选择" style="width:100%" @change="change(scope.row)">
                <el-option v-for="(item, index) in tankList" :key="index" :label="item.tankName" :value="item.id"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="入库量" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.receipt" type="Number" placeholder="请输入" style="width:100%">
                <template slot="append">吨</template>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="left">
            <template slot-scope="scope">
              <el-button size="mini" class="bottom_two" @click="delitem(scope.$index)">
                <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="reset('addDialog1')">取 消</el-button>
        <el-button class="bottom_all" :disabled="!lowData.specialMaterialsMannage.id" style="margin-left: 24px" @click="submit1()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import {
  queryPage,
  saveOrUpdate,
  querySpecialList,
  stationList,
  tankList,
  checkOrIncoming,
  getRawContracts,
  getSpecialMaterialsById,
  warehousing
} from "@/api/smart/specialmaterial/income.js";
import { permissionsCompanyList } from "@/api/common.js";
export default {
  mixins: [mixin],
  data() {
    return {
      /*表格增删改查及下载接口*/
      queryPage: queryPage,
      saveOrUpdate: saveOrUpdate,
      /*表格数据*/
      table: [
        { label: "来料编码", width: "160", prop: "code", status: true },
        { label: "特材原料名称", width: "160", prop: "productName", status: true },
        // { label: "原料型号", width: "160", prop: "productType", status: true },
        { label: "原料供应商", width: "160", prop: "supplier", status: true },
        { label: "所属单位", width: "160", prop: "company", status: true },
        { label: "需求主体", width: "160", prop: "contractSigningSubject", status: true }, 
        { label: "入库量（吨）", width: "120", prop: "num", status: true },
        { label: "原料检验结果", width: "120", prop: "checkResult", status: true },
        { label: "原料复检结果", width: "120", prop: "recheckResult", status: true },
        { label: "备注", width: "300", prop: "remark", status: true },
        { label: "状态", width: "120", prop: "", status: true },
        { label: "更新时间", width: "150", prop: "updateTime", status: true },
        { label: "操作", width: "300", prop: "", status: true },
      ],
      pagesType: 0,
      /*添加表单数据*/
      rules: {
        companyId: [{ required: true, message: "请选择所属单位", trigger: "change" }],
        productId: [{ required: true, message: "请选择特材原料", trigger: "change" }],
        contractId: [{ required: true, message: "请选择供应商合同", trigger: "change" }],
        cooperativeUnitId: [{ required: true, message: "请选择协作单位", trigger: "change" }],
      },
      fromDate: {
        productId: ''
      },
      addDialog1: false,
      /**弹窗原始数据*/
      low: {},
      /**弹窗的新增修改数据*/
      lowData: {
        tanks: [],
        materialNo: '',
        inventoryTime:"",
        specialMaterialsMannage:{
            id:'',
            stock:"",
            rawId:"",
            rawtName:"",
            tank:"",
          },
      },
      companyList: [],
      productList: [],
      stationLost: [],
      contractList:[],
      cooperationsList:[],
      tankList: []
    };
  },
  async created() {
    this.companyList = await permissionsCompanyList()
    /*存储拷贝的原初始化fromDate数据*/
    this.tableParam = { ...this.tableParam, productName: "", productType: "", dataStatus: null };
    stationList({ page: 1, pageSize: 9999999, enable: 1 }).then(res => {
      this.stationLost = res.data.data
    })
    this.gettableData();
  },
  deactivated() {
    this.addDialog = false
  },
  methods: {
    getCantractSup(contractId,companyId,productId,item){
      console.log('1111111')
      this.$set(this.fromDate,'contractId','')
      this.$set(this.fromDate,'supplier','')
      this.$set(this.fromDate,'supplierId','')
      this.$set(this.fromDate,'contractSigningSubject','')
      this.$set(this.fromDate,'contractSigningSubjectId','')
      this.$set(this.fromDate,'cooperativeUnitId','')
      this.cooperationsList = []

      if(item) {
        this.fromDate.productName = item.rawtName
        this.fromDate.rawId = productId
      }
      console.log('222222')
      getRawContracts({companyId:companyId,rawId:productId}).then(res => {
        this.contractList = res.data
        if(contractId) {
          let items = this.contractList.find(res2 => (res2.id == contractId))
          this.cooperationsList = items.cooperations
        }
      })
    },
    selectContract(item){
      this.fromDate.supplier = item.supplierName
      this.fromDate.supplierId = item.supplierId
      this.fromDate.contractSigningSubject = item.needSubject
      this.fromDate.contractSigningSubjectId = item.needSubjectid
      this.cooperationsList = item.cooperations
    },
    productListFun(companyId) {
      this.fromDate.productId = ''
      querySpecialList({ companyId: companyId, page: 1, pageSize: 9999999}).then(res => {
        this.productList = res.data
      })
    },
    change(low) {
      let item = this.tankList.find(res => (res.id == low.id))
      low.inventory = item.inventory
    },
    className({ row }) {
      if (row.status == 0) {
        return 'hidden'
      }
    },
    additem() {
      this.lowData.tanks.push({
        id: '',
        inventory: '',
        receipt: '',
      })
    },
    delitem(index) {
      this.lowData.tanks.splice(index, 1)
    },
    async open(key, low) {
      this.low = this.copy(low)
      if (key == "addDialog1") {
        this[key] = true
        const { data: list } = await tankList({ page: 1, pageSize: 9999999, productId: low.productId })
        this.tankList = list.data
        let arr = []
        if (list.data.length !== 0) {
          arr.push({
            id: '',
            inventory: '',
            receipt: '',
          })
        }
        this.lowData = {
          planId: low.id,
          planStatus: 1,
          materialNo: low.code,
          tanks: arr,
          inventoryTime:"",
          specialMaterialsMannage:{
            id:'',
            stock:"",
            rawId:"",
            rawtName:"",
            tank:"",
          },
        }
        getSpecialMaterialsById({id:low.productId}).then(res => {
          if(res.code == 1001 && res.data) {
            this.lowData.specialMaterialsMannage.id = res.data.id
            this.lowData.specialMaterialsMannage.rawId = res.data.rawId
            this.lowData.specialMaterialsMannage.tank = res.data.tank
            this.lowData.specialMaterialsMannage.rawtName = res.data.rawtName
          }
        })

      }
      if (key == "addDialog2") {
        this.$confirm('此操作会将来料送往检验, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'bottom_all_two',
          confirmButtonClass: 'bottom_all',
          type: 'warning'
        }).then(() => {
          let data = {
            planId: low.id,
            oldStatus: low.dataStatus,
            planStatus: 3,
            companyId: low.companyId,
            company: low.company,
            materialNo: low.code,
            rawID: low.productId,
            rawName: low.productName,
            rawModel: low.productType,
            supplierId: low.supplierId,
            supplierName: low.supplier,
          }
          checkOrIncoming(data).then(res => {
            if (res.code == 1001) {
              this.$message({
                message: "成功送入检验",
                type: 'success'
              });
              this.gettableData();
            }
          })
        }).catch(() => {
        });
      }
    },
    reset(key) {
      this[key] = false
      this.tankList = []
    },
    /*重置数据,此方法必须存在，并且方发只重置条件*/
    init() {
      this.tableParam.productName = "";
      this.tableParam.productType = "";
      this.tableParam.dataStatus = null;
      this.gettableData();
    },
    submit1() {
      let _this = this;
      if (!_this.lowData.specialMaterialsMannage.stock) {
        _this.$message({
          message: "请添加入库数据",
          type: 'warning'
        });
        return
      }
      // if (_this.lowData.tanks.length == 0) {
      //   _this.$message({
      //     message: "请添加入库数据",
      //     type: 'warning'
      //   });
      //   return
      // }
      // if (_this.lowData.tanks.every(item => (item.id == '' || item.receipt == ''))) {
      //   _this.$message({
      //     message: "请填写信息完整",
      //     type: 'warning'
      //   });
      //   return
      // }
      // let hash = {};
      // const deWeight = (item, cur) => {
      //   hash[cur.id] ? '' : hash[cur.id] = true && item.push(cur);
      //   return item
      // }
      // let arr = _this.lowData.tanks.reduce(deWeight, [])
      // if (_this.lowData.tanks.length !== arr.length) {
      //   _this.$message({
      //     message: '不能添加重复的原料罐',
      //     type: 'warning'
      //   });
      //   return
      // }
      warehousing(_this.lowData).then(res => {
        if (res.code == 1001) {
          _this.$message({
            message: '入库成功！',
            type: 'success'
          });
          this.gettableData()
          _this.reset('addDialog1')
        }
      })
    },
    pagessubmitFromDate() {
      let _this = this;
      _this.$refs.reffromDate.validate(async (valid) => {
        if (valid) {
          _this.submitFromDate();
        } else {
          return false;
        }
      });
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
  },
};
</script>

<style lang="scss" scoped>
.el-input,
.el-select,
.el-textarea {
  width: 240px;
}
.hidden {
  display: none;
}
/*
 <el-link class="table_link" :underline="false">查看配合比</el-link>*/
.table_link {
  margin: 0 10px;
  color: $bg_color;
  cursor: pointer;
}

.table_link:hover {
  opacity: 0.8;
}
</style>
